export default "__VITE_ASSET__a67f5d78__"